import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaExternalLinkAlt, FaHome } from "react-icons/fa";

const DiscountPage = () => {
  const navigate = useNavigate();
  const [hasReturned, setHasReturned] = useState(false);
  const hasOpenedExternalRef = useRef(false);

  useEffect(() => {
    // Check if we should auto-open the external link
    const shouldAutoOpen = sessionStorage.getItem('discount_auto_open');
    if (shouldAutoOpen === 'true') {
      // Mark that we've opened the external link
      sessionStorage.setItem('discount_external_opened', 'true');
      sessionStorage.removeItem('discount_auto_open');
      hasOpenedExternalRef.current = true;
      // Auto-open the external link
      setTimeout(() => {
        window.open("https://discount.nandosess.ae", "_blank");
      }, 300);
    } else {
      // Check if user is returning from external site
      const openedExternal = sessionStorage.getItem('discount_external_opened');
      if (openedExternal === 'true') {
        hasOpenedExternalRef.current = true;
      }
    }

    // Detect when user returns to the app
    const handleVisibilityChange = () => {
      if (!document.hidden && hasOpenedExternalRef.current) {
        // User has returned from external site
        setHasReturned(true);
        // Clear the flag
        sessionStorage.removeItem('discount_external_opened');
        hasOpenedExternalRef.current = false;
      }
    };

    // Also check on window focus
    const handleFocus = () => {
      if (hasOpenedExternalRef.current) {
        setHasReturned(true);
        sessionStorage.removeItem('discount_external_opened');
        hasOpenedExternalRef.current = false;
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    // Check immediately if we're returning
    const openedExternal = sessionStorage.getItem('discount_external_opened');
    if (openedExternal === 'true' && document.hasFocus() && !shouldAutoOpen) {
      // Small delay to ensure we're back
      setTimeout(() => {
        setHasReturned(true);
        sessionStorage.removeItem('discount_external_opened');
        hasOpenedExternalRef.current = false;
      }, 500);
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  const handleGoToDashboard = () => {
    navigate('/employee-dashboard');
  };

  const handleOpenDiscount = () => {
    // Mark that we're opening external link
    sessionStorage.setItem('discount_external_opened', 'true');
    hasOpenedExternalRef.current = true;
    window.open("https://discount.nandosess.ae", "_blank");
  };

  return (
    <div className="page-wrapper" style={{ paddingBottom: window.innerWidth < 768 ? "80px" : "0" }}>
      <div className="content container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div 
              style={{
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                borderRadius: "12px",
                padding: "40px 24px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                marginTop: "40px",
                textAlign: "center"
              }}
            >
              <div style={{ marginBottom: "24px" }}>
                <div 
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 20px",
                    boxShadow: "0 4px 12px rgba(211, 0, 26, 0.3)"
                  }}
                >
                  <FaExternalLinkAlt size={36} color="#ffffff" />
                </div>
                <h2 style={{ 
                  fontSize: "28px", 
                  fontWeight: "600", 
                  color: "#1f2937",
                  marginBottom: "12px"
                }}>
                  Discount Portal
                </h2>
                <p style={{ 
                  fontSize: "16px", 
                  color: "#6b7280",
                  marginBottom: "0"
                }}>
                  You are being redirected to our discount portal
                </p>
              </div>

              {hasReturned && (
                <div 
                  style={{
                    background: "#fef2f2",
                    border: "2px solid rgb(211, 0, 26)",
                    borderRadius: "10px",
                    padding: "20px",
                    marginBottom: "24px"
                  }}
                >
                  <p style={{ 
                    fontSize: "16px", 
                    color: "#1f2937",
                    marginBottom: "16px",
                    fontWeight: "500"
                  }}>
                    Welcome back! Hope you found great deals.
                  </p>
                  <button
                    onClick={handleGoToDashboard}
                    style={{
                      background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      color: "#ffffff",
                      fontSize: "15px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.2s ease",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.3)"
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 4px 12px rgba(211, 0, 26, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 2px 8px rgba(211, 0, 26, 0.3)";
                    }}
                  >
                    <FaHome size={16} />
                    Go to Dashboard
                  </button>
                </div>
              )}

              <div style={{ marginTop: "24px" }}>
                <button
                  onClick={handleOpenDiscount}
                  style={{
                    background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                    border: "none",
                    borderRadius: "8px",
                    padding: "14px 28px",
                    color: "#ffffff",
                    fontSize: "16px",
                    fontWeight: "600",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    transition: "all 0.2s ease",
                    boxShadow: "0 2px 8px rgba(211, 0, 26, 0.3)"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 4px 12px rgba(211, 0, 26, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 2px 8px rgba(211, 0, 26, 0.3)";
                  }}
                >
                  <FaExternalLinkAlt size={16} />
                  Open Discount Portal
                </button>
              </div>

              <p style={{ 
                fontSize: "14px", 
                color: "#9ca3af",
                marginTop: "24px",
                marginBottom: "0"
              }}>
                The discount portal will open in a new tab
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountPage;

